export const RESET_FORGET_PASSWORD = "RESET_FORGET_PASSWORD";

export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";

export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const SET_NEW_PASSWORD_SUCCESS = "SET_NEW_PASSWORD_SUCCESS";

export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";
